import React from 'react';
import { Alert } from '@mui/material';

/** Customer name and email from orders are sent to the AI provider the owner connected. */
export default function PrivacyNote({ sx }) {
  return (
    <Alert severity="info" variant="outlined" sx={sx}>
      To answer your goals, your team reads recent orders and stock from your store. Customer names and email
      addresses from orders are sent to the AI provider you connected. Phone numbers and addresses are not shared.
    </Alert>
  );
}
